import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  TagRightIcon,
  useToast,
  VStack
} from '@chakra-ui/react'
import { Form } from './Form'
import usePrizes from './hooks/usePrizes'
import { AdminSeason, AdminClawMachinePrize } from '@olagg/db-types'
import { SeasonFormData } from '@olagg/validation-schemas/season.schema'

const Edit = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getPrize, updatePrize, loading } = usePrizes()

  const [prize, setPrize] = useState<AdminClawMachinePrize | null>(null)
  const [loadingPrize, setLoadingPrize] = useState(true)

  useEffect(() => {
    const loadPrize = async () => {
      if (!id) return
      try {
        setLoadingPrize(true)
        const prizeData = await getPrize(id)
        setPrize(prizeData.clawMachinePrize)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar el premio',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate('/claw-machine-prizes')
      } finally {
        setLoadingPrize(false)
      }
    }

    loadPrize()
  }, [id])

  const onSubmit = async (data: SeasonFormData) => {
    if (!prize) return

    try {
      await updatePrize(prize.id, data)
      toast({
        title: 'Premio actualizado',
        description: 'El premio ha sido actualizado exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate('/claw-machine-prizes')
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar el premio',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate('/claw-machine-prizes')
  }

  if (loadingPrize) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!prize) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Premio no encontrado
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar premio</Heading>

        <Form
          initialData={prize}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default Edit;